<div class="confirmDialog">
    <h1 mat-dialog-title>
        {{title}}
    </h1>
    <mat-dialog-content [formGroup]="form" class="flex flex-col">
        <div>{{message}}</div>
        <mat-form-field *ngIf="inputBox">
            <input matInput
                   [hidden]="hideTextField"
                   placeholder="{{dataName}}"
                   formControlName="dataValue">
        </mat-form-field>
        <mat-form-field *ngIf="textBox">
            <textarea matInput
                rows="5"
                [hidden]="hideTextField"
                placeholder="{{dataName}}"
                formControlName="dataValue">
            </textarea>
        </mat-form-field>


    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button  mat-button class="mat-raised-button mat-secondary" (click)="onDismiss()">{{cancelTitle}}</button>
        <button  mat-button class="mat-raised-button mat-primary" (click)="onConfirm()">{{acceptTitle}}</button>
    </mat-dialog-actions>
</div>
